import { decodeHTMLEntities } from './_utils';

export function initializeModalGallery() {
    let currentGallery = 0;
    let currentImageIndex = 0;

    function openGallery(index) {
        currentGallery = 0; // Since there's only one gallery
        currentImageIndex = index;
        updateModal();
        jQuery("#galleryModal").removeClass("hidden");
    }

    function closeGallery() {
        jQuery("#galleryModal").addClass("hidden");
    }

    function updateModal() {
        const gallery = window.galleriesData[currentGallery];
        const modalImage = document.getElementById("modalImage");
        const modalCaption = document.getElementById("modalCaption");
        const modalLoadingSpinner = document.getElementById("loadingSpinner");

        if (modalImage) {
            modalImage.style.opacity = "0.5";
        }
        //document.getElementById("loadingSpinner").classList.remove("hidden");
        if (modalLoadingSpinner) {
            modalLoadingSpinner.classList.remove("hidden");
        }
        if (modalImage && gallery && gallery.images && gallery.images[currentImageIndex] && gallery.images[currentImageIndex].url) {
            modalImage.src = gallery.images[currentImageIndex].url;
        }

        // const captionText = gallery.images[currentImageIndex]?.caption?.trim() || gallery.name?.trim() || "";
        var captionText = "";
        if (gallery && gallery.images && gallery.name && gallery.images[currentImageIndex] && gallery.images[currentImageIndex].caption) {
            captionText = gallery.images[currentImageIndex]?.caption?.trim() || gallery.name?.trim() || "";
        }

        if (modalCaption) {
            if (captionText) {
                modalCaption.textContent = decodeHTMLEntities(captionText);
                modalCaption.style.display = "block";
            } else {
                modalCaption.textContent = "";
                modalCaption.style.display = "none";
            }
        }
        if (modalImage) {
            modalImage.onload = function() {
                modalImage.style.opacity = "1";
                //document.getElementById("loadingSpinner").classList.add("hidden");
                if (modalLoadingSpinner) {
                    modalLoadingSpinner.classList.add("hidden");
                }
            };
        }
    }

    function nextImage() {
        currentImageIndex = (currentImageIndex + 1) % window.galleriesData[currentGallery].images.length;
        updateModal();
    }

    function prevImage() {
        currentImageIndex = (currentImageIndex - 1 + window.galleriesData[currentGallery].images.length) % window.galleriesData[currentGallery].images.length;
        updateModal();
    }

    // Initialize all event listeners
    jQuery(document).ready(function($) {
        $(".slide-image, .gallery-image").on("click", function() {
            const index = $(this).data("image-index");
            openGallery(index);
        });        

        $("#closeGallery").on("click", closeGallery);
        $("#nextImage").on("click", nextImage);
        $("#prevImage").on("click", prevImage);

        $("#galleryModal").on("click", function(event) {
            if (event.target === this) {
                closeGallery();
            }
        });

        $(document).on("keydown", function(event) {
            if ($("#galleryModal").is(":visible")) {
                switch (event.key) {
                    case "Escape":
                        closeGallery();
                        break;
                    case "ArrowLeft":
                        prevImage();
                        break;
                    case "ArrowRight":
                        nextImage();
                        break;
                }
            }
        });
    });
}